/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable no-restricted-syntax */

/* eslint-disable no-await-in-loop */
import axios from 'axios';
import dayjs from 'dayjs';
import { Field, Form, Formik } from 'formik';
import { Select as FormikSelect } from 'formik-mui';
import { DatePicker as FormikDatePicker } from 'formik-mui-x-date-pickers';

import { Box, Button, Card, MenuItem, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import React, { useEffect, useState } from 'react';

import { toast } from 'react-toastify';

import { useAuth } from '@src/contexts/authContext';
import { FormikAutocomplete } from '@src/utils';

const url = `${process.env.REACT_APP_API_URL}`;

export default function SendReports() {
  const { auth } = useAuth();
  const [branches, setBranches] = useState([]);
  const [isFixClicked, setIsFixClicked] = useState(false);

  useEffect(() => {
    if (auth?.idToken) {
      axios
        .get(`${url}/admin/clinics`, {
          headers: {
            Authorization: `Bearer ${auth.idToken}`,
          },
        })
        .then((res) => setBranches(res.data || []))
        .catch((err) => console.error('Error fetching clinics:', err));
    }
  }, [auth?.idToken]);

  const handleFixReport = async ({ clinicId, startDate }) => {
    const month = dayjs(startDate).format('MM');
    const year = dayjs(startDate).format('YYYY');

    try {
      await axios.get(
        `${url}/admin/v3/financial-reports/branchs/fix-financial-reports-db/${clinicId}/${month}/${year}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${auth.idToken}`,
          },
        },
      );

      toast.success('Fix report executed successfully', {
        position: 'top-center',
        autoClose: 2000,
      });

      setIsFixClicked(true);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || 'Fix report failed', {
        position: 'top-center',
        autoClose: 2000,
      });
    }
  };

  const handleSendReport = async (values) => {
    const { clinicId, type, startDate } = values;
    const month = dayjs(startDate).format('MM');
    const year = dayjs(startDate).format('YYYY');

    if (type === 'one') {
      const params = new URLSearchParams({ clinic_id: clinicId, month, year });
      await axios.get(
        `${url}/admin/v3/financial-reports/branchs/generate-send-to-clinic?${params}`,
        { headers: { Authorization: `Bearer ${auth.idToken}` } },
      );
    } else {
      const params = new URLSearchParams({ month, year });
      await axios.get(
        `${url}/admin/v3/financial-reports/branchs/generate?${params}`,
        { headers: { Authorization: `Bearer ${auth.idToken}` } },
      );
    }

    // setIsFixClicked(true);
    toast.success('Report sent successfully', {
      position: 'top-center',
      autoClose: 2000,
    });
  };

  return (
    <Box sx={{ justifyContent: 'center', p: 3 }}>
      <Card
        sx={{
          p: 5,
          backgroundColor: 'white',
          width: '650px',
          borderRadius: '16px',
        }}
      >
        <Formik
          initialValues={{
            type: '',
            clinicId: '',
            startDate: null,
          }}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              const { type, clinicId, startDate } = values;

              if (!type || !startDate) {
                toast.error('Please select type and date.', {
                  position: 'top-center',
                });
                return;
              }

              if (type === 'one' && !clinicId) {
                toast.error('Please select a branch.', {
                  position: 'top-center',
                });
                return;
              }

              await handleSendReport(values);
            } catch (err) {
              toast.error('Failed to send report', { position: 'top-center' });
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ values, isSubmitting, isValid, dirty }) => (
            <Form>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '24px',
                  alignItems: 'center',
                }}
              >
                {/* Type */}
                <Box sx={{ width: '100%' }}>
                  <Typography fontFamily='Poppins'>Choose Type*</Typography>
                  <Field
                    component={FormikSelect}
                    name='type'
                    displayEmpty
                    fullWidth
                    sx={{ mt: 2, width: '570px' }}
                  >
                    <MenuItem disabled value=''>
                      <em style={{ color: '#8C8C8C' }}>Select</em>
                    </MenuItem>
                    <MenuItem value='one'>One Branch</MenuItem>
                    <MenuItem value='all'>All Branches</MenuItem>
                  </Field>
                </Box>

                {/* Branch Select */}
                {values.type === 'one' && (
                  <Box sx={{ width: '100%' }}>
                    <Typography fontFamily='Poppins'>Choose Branch*</Typography>
                    <FormikAutocomplete
                      name='clinicId'
                      // label='Choose Branch*'
                      options={[...branches].sort((a, b) =>
                        a.clinicName.localeCompare(b.clinicName),
                      )}
                      getOptionLabel={(option) => option.clinicName || ''}
                      fullWidth
                      sx={{ mt: 2, width: '650px' }}
                    />
                  </Box>
                )}

                {/* Date Picker */}
                <Box sx={{ width: '100%' }}>
                  <Typography fontFamily='Poppins'>
                    Choose Month & Year*
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Field
                      component={FormikDatePicker}
                      name='startDate'
                      inputFormat='MM YYYY'
                      views={['year', 'month']}
                      sx={{ width: '100%', mt: 1 }}
                      fullWidth
                      textField={{
                        helperText: 'Select date',
                        variant: 'outlined',
                      }}
                    />
                  </LocalizationProvider>
                </Box>

                {/* Fix Button */}
                {values.type === 'one' && (
                  <Button
                    variant='contained'
                    className='bg-[#9081D5]'
                    onClick={() =>
                      handleFixReport({
                        clinicId: values.clinicId,
                        startDate: values.startDate,
                      })
                    }
                    disabled={!values.clinicId || !values.startDate}
                    sx={{
                      mt: 1,
                      py: 2,
                      width: '300px',
                      textTransform: 'capitalize',
                      fontSize: '1.1rem',
                    }}
                  >
                    Fix Report
                  </Button>
                )}

                {/* Submit Button */}
                <Button
                  type='submit'
                  variant='contained'
                  className='bg-cyan-600'
                  disabled={
                    (values.type === 'one' && !isFixClicked) ||
                    isSubmitting ||
                    !isValid ||
                    !dirty
                  }
                  sx={{
                    py: 2,
                    width: '300px',
                    fontSize: '1.1rem',
                    textTransform: 'capitalize',
                  }}
                >
                  {isSubmitting ? 'Sending...' : 'Send Report'}
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Card>
    </Box>
  );
}
